<script lang="ts">
  import {onMount} from 'svelte'
  import * as Chartist from 'chartist'
  import api from '../api/api'
  import {t} from '../i18n'
  import Dropdown from '../../src/shared/Dropdown.svelte'

  let periods = ['last_week', 'last_2_weeks', 'last_month']
  let period = 'last_week'
  let statisticTypes = ['received', 'given']
  let statisticType = 'received'
  let fields = ['views', 'likes', 'comments']
  let field = 'views'
  let statistics: any = null
  let chartRef: HTMLElement

  // Function to fetch statistics data
  async function fetchStatistics() {
    statistics = await api.get('/users/statistics')
    setChart()
  }

  function onChangeChart(newField: string) {
    field = newField
    setChart()
  }

  function setChart() {
    if (!statistics || !chartRef) return

    const chartData = statistics.detailed[period][field]
    const chartOptions = {
      fullWidth: true,
      chartPadding: {
        right: 40
      },
      lineSmooth: Chartist.Interpolation.simple({
        divisor: 10
      }),
      axisY: {
        showGrid: false,
        labelInterpolationFnc: (value: number) =>
          isNaN(value) || value % 1 === 0 ? value : ''
      }
    }

    const chart = new Chartist.LineChart(
      chartRef,
      {
        labels: Object.keys(chartData),
        series: [Object.values(chartData)]
      },
      chartOptions
    )

    // Customize chart points
    chart.on('draw', (data: any) => {
      if (data.type === 'point') {
        const circle = new Chartist.Svg(
          'circle',
          {
            cx: data.x,
            cy: data.y,
            r: 5
          },
          'ct-circle'
        )
        data.element.replace(circle)
      }
    })
  }

  onMount(fetchStatistics)
</script>

<div class="row">
  <div class="account_block">
    <h1>{t.users.statistics.title}</h1>
    <div class="account__content">
      <div class="stat-heading clearfix">
        <div class="stat-tabs-wrap">
          {#each fields as f}
            <div class="stat-tabs-item" class:active={field === f} onclick={() => onChangeChart(f)}>
              <i class="icon-p-{f}" />
              <span>{t.users.statistics[f].count}</span>
            </div>
          {/each}
        </div>

        <div class="stat-sort">
          <Dropdown bind:value={period} onChange={() => setChart()}
                    options={periods.map(p => ({value: p, label: t.users.statistics.period[p]}))}/>
        </div>
      </div>
      <div class="stat-chart" bind:this={chartRef}></div>

      {#if statistics}
        <div class="rg-wrap">
          <div class="rg-tab">
            {#each statisticTypes as type}
              <a class="rg-tab-item r-tab"
                 class:inactive={statisticType !== type}
                 onclick={(e) => {e.preventDefault(); statisticType = type}}>
                {t[`users.statistics.${type}`]}
              </a>
            {/each}
          </div>
          <div class="gr-tab-content">
            <div class="rg-count-item">
              <span class="rg-count rg-count-views">
                {statistics[statisticType][period].views}
              </span>
              <small>{t.users.statistics.views.count}</small>
            </div>
            <div class="rg-count-item">
              <span class="rg-count rg-count-likes">
                {statistics[statisticType][period].likes}
              </span>
              <small>{t.users.statistics.likes.count}</small>
            </div>
            <div class="rg-count-item">
              <span class="rg-count rg-count-comments">
                {statistics[statisticType][period].comments}
              </span>
              <small>{t.users.statistics.comments.count}</small>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>
